import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ApiService} from '../../../../services/api.service';
import {ServicerTransferSummary} from '../../../../model/servicerTransferSummary';
import {ApproveAndDeleteServicerTransferSummary} from '../../../../model/approveAndDeleteServicerTransferSummary';
import {TransactionWrapper} from '../../../../model/transactionWrapper';
import {Constants} from '../../../../constants/ebtq-constants';
import {UtilityService} from '../../../../services/utility-service';
import {mergeMap} from 'rxjs/operators';
import {Location} from '@angular/common';
import {forkJoin} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {ServicerTransferSummaryList} from '../../../../model/servicerTransferSummaryList';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-service-transfer-portfolio-indicator',
  templateUrl: './service-transfer-portfolio-indicator.component.html',
  styleUrls: ['./service-transfer-portfolio-indicator.component.scss']
})
export class ServiceTransferPortfolioIndicatorComponent implements OnInit {

  cols: any[];
  displayCols: any[];
  deleteCols: any[];
  containsError = false;
  errorMsg: string;
  servicerTransferSummaryData: ServicerTransferSummary;
  transactionWrapper: TransactionWrapper;
  partialLoanDetailsList: any[] = [];
  partialLoanDeleteDetailsList : any[];
  partialLoanDisplayList: any[] = [];

  noTranSel: string;
  deleteFlag = false;
  deleteConfirmFlag = false;

  @ViewChildren('deleteCheckbox')
    deleteCheckboxes: QueryList<ElementRef>;

  internalUpdateRoleFlag: string;
  externalUpdateRoleFlag: string;
  isAdminrole: string;

  servicerTransferSummaryList: ServicerTransferSummaryList;

  constructor(private apiService: ApiService, private utilityService: UtilityService,
              private location: Location,  private router: Router, private route: ActivatedRoute,
              private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {


    this.externalUpdateRoleFlag = sessionStorage.getItem('isRMExternal_Servicing_Update');

    this.internalUpdateRoleFlag = sessionStorage.getItem('isRMInternal_Update');
    this.isAdminrole = sessionStorage.getItem('isAdmin');

    this.cols = [
      {field: 'TRAN_ID', header: 'Delete ?'},
      {field: 'FNM_LN_NO', header: 'Loan Number'},
      /*{field: 'TRAN_STAT_CD', header: 'Transaction Status Code'},*/
      {field: 'TRAN_STAT_DESC', header: 'Transaction Status'}
    ];

    this.deleteCols = [

      {field: 'FNM_LN_NO', header: 'Loan Number'},
      /*{field: 'TRAN_STAT_CD', header: 'Transaction Status Code'},*/
      {field: 'TRAN_STAT_DESC', header: 'Transaction Status'}
    ];

    this.displayCols = this.displayColumns();
    this.servicerTransferSummaryData = this.apiService.getServiceTransferForPartial();
    this.serviceTransferLoanList(this.servicerTransferSummaryData);
    this.route.queryParams.subscribe(params => {
      this.servicerTransferSummaryList = JSON.parse(atob(params.query));
      this.cdr.detectChanges();
    });


  }


  displayColumns() {

    return this.cols.filter(col =>{
      if (!this.roleCheck())
      {
        return col.field !== 'TRAN_ID';
      }
      return true;
    }).map(col => col);




  }
  roleCheck()
  {
    return (this.isAdminrole === 'true') || (this.internalUpdateRoleFlag === 'true')
      || (this.externalUpdateRoleFlag === 'true');
  }

  selectAll()
  {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      if (!(<any>deleteCheckbox).disabled) {
        (<any>deleteCheckbox).checked = true;
      }
    });

  }


  unSelectAll()
  {
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      (<any>deleteCheckbox).checked = false;
    });

  }

  public serviceTransferLoanList(serviceTransfer)
  {


    const creationDateVal = this.utilityService.convertDateToMillisec(serviceTransfer.creationDateConverted);
    const effectiveDateVal = this.utilityService.convertDateToMillisec(serviceTransfer.effectiveDateConverted);
    const profileInd = this.utilityService.getProfileCode(serviceTransfer.portfolioIndicator);



    const partialLoanServicerSummary : ApproveAndDeleteServicerTransferSummary = {
      rownum : serviceTransfer.rownum,
      effectiveDate : {date: effectiveDateVal},
      creationDate :  {date: creationDateVal},
      servicerNumberTo : serviceTransfer.servicerNumberTo,
      servicerNumberFrom : serviceTransfer.servicerNumberFrom,
      originalCount : serviceTransfer.originalCount,
      processedCount : serviceTransfer.processedCount,
      deletedCount : serviceTransfer.deletedCount,
      portfolioIndicator : profileInd,
      servTransferStatus : serviceTransfer.servTransferStatus,
      submissionId : serviceTransfer.submissionId
    };

    this.transactionWrapper = new TransactionWrapper();


    this.transactionWrapper.queryServiceName = Constants.GET_SERV_XFER_PARTIAL_LOAN_LIST_ALL_PKS;



    // this.transactionWrapper.parameters[0] = userId;
    //this.transactionWrapper.parameters[1] = this.approveDeleteServiceTransferList;
    this.transactionWrapper.parameters[0] = partialLoanServicerSummary;




    //this.apiService.getPartialLoanDetailsList(this.transactionWrapper).pipe(
    this.apiService.executeQuery(this.transactionWrapper).pipe(
      mergeMap(resp1 => {
        /* Commenting for large data handling
          this.transactionWrapper.queryServiceName = Constants.GET_SERV_XFER_PARTIAL_LOAN_DATA_FOR_PKS;
          this.transactionWrapper.parameters[0] = (<any> resp1).object;
          return this.apiService.getPartialLoanDetailsList(this.transactionWrapper);*/
        this.transactionWrapper.queryServiceName = Constants.GET_SERV_XFER_PARTIAL_LOAN_DATA_FOR_PKS;

        const responseArray: any[] = (<any> resp1).object;
        const observables : any[] = [];;


        while (responseArray.length > 200)
        {
          this.transactionWrapper = new TransactionWrapper();
          this.transactionWrapper.queryServiceName = Constants.GET_SERV_XFER_PARTIAL_LOAN_DATA_FOR_PKS;
          const secondArray = responseArray.splice(0, 200);
          this.transactionWrapper.parameters[0] = secondArray;
          // observables.push(this.apiService.getPartialLoanDetailsList(this.transactionWrapper));
          observables.push(this.apiService.executeQuery(this.transactionWrapper));

        }
        this.transactionWrapper = new TransactionWrapper();
        this.transactionWrapper.queryServiceName = Constants.GET_SERV_XFER_PARTIAL_LOAN_DATA_FOR_PKS;
        this.transactionWrapper.parameters[0] = responseArray;
        // observables.push(this.apiService.getPartialLoanDetailsList(this.transactionWrapper));
        observables.push(this.apiService.executeQuery(this.transactionWrapper));

        return forkJoin(observables);


      })
    ).subscribe(data=>{
      const utilService = new UtilityService();
      /* Commenting for large dta transfer
        //{TRAN_ID: 487653923, FNM_LN_NO: '6000040712', TRAN_STAT_CD: 3}
        this.partialLoanDetailsList = (<any> data).object;*/
      const responseArray : any[] = (<any> data);

      for (let i = 0;  i < responseArray.length; i++)
      {
        responseArray[i].object.forEach(element => {
          this.partialLoanDetailsList.push(element);
        });

      }


      this.partialLoanDetailsList.forEach(function(part, index, array) {

        /** Get the label value from utilService */
        utilService.transactionStatusType.forEach(function(part1, index1, array1) {
          // TRAN_STAT_CD comes from the API as a number, lookup values are strings.
          if (array1[index1].value === String(array[index].TRAN_STAT_CD)) {
            array[index].TRAN_STAT_DESC = array1[index1].label;

          }
        });

      });

      this.partialLoanDisplayList = [];
      this.partialLoanDisplayList = this.partialLoanDisplayList.concat(this.partialLoanDetailsList);

      /*  this.partialLoanDisplayList =[{TRAN_ID: 487653923, FNM_LN_NO: '6000040712', TRAN_STAT_CD: 3}];
      */
      this.cdr.detectChanges();

    },
    error=>{
      this.cdr.detectChanges();
    });

  }


  cancelButton() {
    this.router.navigate(['serviceTransfersResults'], {
      queryParams: {query: btoa(JSON.stringify(this.servicerTransferSummaryList))}
    });

  }

  cancelDelete() {

    this.deleteFlag = false;
    this.displayCols = this.displayColumns();
    this.partialLoanDisplayList = this.partialLoanDetailsList;
  }

  confirmDelete()
  {

    const userId = sessionStorage.getItem('userID');
    const transIds = [];

    this.partialLoanDeleteDetailsList.forEach(loan=>{
      transIds.push(loan.TRAN_ID);
    });




    this.transactionWrapper = new TransactionWrapper();


    this.transactionWrapper.queryServiceName = Constants.DELETE_SERV_XFER_PARTIAL_LOAN;



    this.transactionWrapper.parameters[0] = userId;
    this.transactionWrapper.parameters[1] = transIds;




    // this.apiService.deletePartialLoanList(this.transactionWrapper).subscribe(data=>{
    this.apiService.executeQuery(this.transactionWrapper).subscribe(data=>{
      this.deleteConfirmFlag = true;


    },
    error=>{
    });






  }


  deleteLoanTrans()
  {
    this.partialLoanDeleteDetailsList = [];
    this.deleteCheckboxes.forEach(deleteCheckbox=>{
      if ((<any>deleteCheckbox).checked)
      {
        this.partialLoanDeleteDetailsList.push((<any>deleteCheckbox).value);

      //  this.deleteServiceTransferList.push((<any>deleteCheckbox).value);
      }


    });

    if (this.partialLoanDeleteDetailsList.length > 0)
    {
      this.deleteFlag = true;
      this.displayCols = this.deleteCols;
      this.partialLoanDisplayList = this.partialLoanDeleteDetailsList;
      /* this.apiService.saveApprovedDeletedList(this.deleteServiceTransferList);
      this.router.navigate(['/confirmDelete'],{queryParams:{
          flag: 'delete'
        }});*/
    }
    else {
      this.noTranSel = 'No Loans selected for delete.';
    }


  }
}
